export const PRAXA_CUSTOMIZE_TABS = [
  { id: "connectors", label: "Connectors", searchLabel: "Connectors" },
  { id: "mcps", label: "MCPs", searchLabel: "MCPs" },
  { id: "skills", label: "Skills", searchLabel: "Skills" },
  { id: "subagents", label: "Subagents", searchLabel: "Subagents" },
  { id: "hooks", label: "Hooks", searchLabel: "Hooks" },
  { id: "workflows", label: "Workflows", searchLabel: "Workflows" },
  { id: "loops", label: "Loops", searchLabel: "Loops" },
] as const;

export type PraxaCustomizeTab = (typeof PRAXA_CUSTOMIZE_TABS)[number]["id"];

export interface PraxaCustomizeSearch {
  readonly tab: PraxaCustomizeTab;
  readonly q?: string;
}

export function isPraxaCustomizeTab(value: unknown): value is PraxaCustomizeTab {
  return PRAXA_CUSTOMIZE_TABS.some((tab) => tab.id === value);
}

export function praxaCustomizeTabForKey(
  currentTab: PraxaCustomizeTab,
  key: string,
): PraxaCustomizeTab | null {
  const currentIndex = PRAXA_CUSTOMIZE_TABS.findIndex((tab) => tab.id === currentTab);
  switch (key) {
    case "ArrowLeft":
      return PRAXA_CUSTOMIZE_TABS[
        (currentIndex - 1 + PRAXA_CUSTOMIZE_TABS.length) % PRAXA_CUSTOMIZE_TABS.length
      ]!.id;
    case "ArrowRight":
      return PRAXA_CUSTOMIZE_TABS[(currentIndex + 1) % PRAXA_CUSTOMIZE_TABS.length]!.id;
    case "Home":
      return PRAXA_CUSTOMIZE_TABS[0].id;
    case "End":
      return PRAXA_CUSTOMIZE_TABS.at(-1)!.id;
    default:
      return null;
  }
}

export function parsePraxaCustomizeSearch(search: Record<string, unknown>): PraxaCustomizeSearch {
  const tab = isPraxaCustomizeTab(search.tab) ? search.tab : "connectors";
  const query = typeof search.q === "string" ? search.q.trim().slice(0, 120) : "";
  return query ? { tab, q: query } : { tab };
}

export function praxaCustomizeSearchPlaceholder(
  tab: PraxaCustomizeTab,
  workspaceLabel: string,
): string {
  const tabDefinition = PRAXA_CUSTOMIZE_TABS.find((candidate) => candidate.id === tab);
  return `Search ${tabDefinition?.searchLabel ?? "customizations"} for ${workspaceLabel}...`;
}
